import { useEffect, useState } from "react";
import { Stack, Typography } from "@mui/material";

import { interval, isWithinInterval } from "date-fns";

import { WIPMessageUrl } from "constants/constants";
import useLanguage from "hooks/useLanguage";
import { isWIPMessageType, IWIPMessage } from "interfaces/wipMessage.interface";

const filePath =
  import.meta.env.MODE === "production" ? "prod.json" : "dev.json";

type WIPMessageProps = {
  messageKey: string;
};

export function WIPMessage({ messageKey }: WIPMessageProps) {
  const { language } = useLanguage();
  const [wipMessages, setWipMessages] = useState<IWIPMessage[]>();

  useEffect(() => {
    fetch(`${WIPMessageUrl}/${filePath}`)
      .then((res) => res.json())
      .then((response) => {
        const data = response?.auth?.[messageKey];

        if (data && isWIPMessageType(data)) {
          setWipMessages(data);
        }
      })
      .catch(() => {});
  }, [messageKey]);

  if (!wipMessages) {
    return null;
  }

  return (
    <>
      {wipMessages
        .filter((wipMessage) => wipMessage.enabled)
        .filter((wipMessage) =>
          isWithinInterval(
            new Date(),
            interval(wipMessage.enable_from, wipMessage.enable_to),
          ),
        )
        .map((wipMessage) =>
          language === "en" ? (
            <MessageComponent
              key={JSON.stringify(wipMessage)}
              title={
                wipMessage.message.en?.title || wipMessage.message.no.title
              }
              body={wipMessage.message.en?.body || wipMessage.message.no.body}
            />
          ) : (
            <MessageComponent
              key={JSON.stringify(wipMessage)}
              title={wipMessage.message.no.title}
              body={wipMessage.message.no.body}
            />
          ),
        )}
    </>
  );
}

const MessageComponent = ({ title, body }: { title: string; body: string }) => {
  return (
    <Stack
      gap={2}
      margin={2}
      marginTop={10}
      padding={2}
      border={"1px solid"}
      borderColor={"divider"}
      textAlign={"center"}
      color={"error"}
    >
      <Typography>{title}</Typography>
      <Typography>{body}</Typography>
    </Stack>
  );
};
